/* eslint-disable no-const-assign */
// eslint-disable-next-line no-unused-vars
import { Modal } from 'bootstrap';
import lottie from 'lottie-web';
import AOS from 'simple-aos';
import Swiper from 'swiper';

AOS.init({
	disable: window.matchMedia('(prefers-reduced-motion: reduce)'), // reduce motion when user has set prefers-reduced-motion for accessibility
	easing: 'ease-in-out',
	duration: 800,
	offset: 80,
	once: true,
});

function isMobile() {
	return window.matchMedia('only screen and (max-width: 760px)').matches;
}

document.addEventListener('DOMContentLoaded', () => {
	// eslint-disable-next-line no-unused-vars
	const clientsSwiper = new Swiper('.swiper-container', {
		slidesPerView: 2,
		spaceBetween: 2,
		// freeMode: true,
		loop: true,
		loopedSlides: 6,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: true,
		},
		speed: 4000,
		breakpoints: {
			768: {
				slidesPerView: 4,
				spaceBetween: 10,
			},
			1240: {
				slidesPerView: 6,
				spaceBetween: 20,
				loop: false,
			},
		},
	});
});

// videos
document.addEventListener('DOMContentLoaded', () => {
	// Select all video elements on the page
	const videos = document.querySelectorAll('video');

	// Play each video and set up event listeners
	videos.forEach((video) => {
		let intervalRewind;

		// Ensure the video is muted for autoplay
		video.muted = true;

		video.play();

		// Clear any existing rewind interval
		clearInterval(intervalRewind);

		if (video.id === 'header-video') {
			// Event listener for mouseover to play the video
			video.addEventListener('mouseover', () => {
				clearInterval(intervalRewind);
				video.play();
			});

			// Event listener for mouseout to rewind the video
			video.addEventListener('mouseout', () => {
				intervalRewind = setInterval(() => {
					video.pause();
					video.currentTime -= 0.1;
					if (video.currentTime <= 0) {
						clearInterval(intervalRewind);
					}
				}, 100);
			});
		}
	});
});

// ************* //////// ************* //
// ** lottie animation  ** //
// ************* //////// ************* //

const lottieContainer = document.getElementById('lottie-background');

let animation;
if (!isMobile()) {
	// Load Lottie animation for non-mobile screens
	animation = lottie.loadAnimation({
		container: lottieContainer,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/wp-content/themes/taboola/dist/assets/web-Creative_Shop-Creative_Services_BG.json', // Path to the JSON file
	});
} else {
	// Load image for mobile screens
	lottieContainer.style.backgroundImage =
		'url(/wp-content/themes/taboola/dist/images/creative-services.jpg)';
	lottieContainer.style.backgroundSize = 'contain';
	lottieContainer.style.backgroundRepeat = 'no-repeat';
}

function updateAnimation() {
	const startScroll = 100;
	const endScroll = 4500;
	const scrollPosition = window.scrollY;
	if (scrollPosition >= startScroll && scrollPosition <= endScroll) {
		const frame =
			animation.totalFrames *
			((scrollPosition - startScroll) / (endScroll - startScroll));
		animation.goToAndStop(frame, true);
	}
}

window.addEventListener('scroll', updateAnimation);

// ************* //////// ************* //
// ** // Typewriter effect  ** //
// ************* //////// ************* //

class TxtType {
	constructor(el, toRotate, period) {
		this.toRotate = toRotate;
		this.el = el;
		this.loopNum = 0;
		this.period = parseInt(period, 10) || 2000;
		this.txt = '';
		this.tick();
		this.isDeleting = false;
	}

	tick() {
		const i = this.loopNum % this.toRotate.length;
		const fullTxt = this.toRotate[i];

		if (this.isDeleting) {
			this.txt = fullTxt.substring(0, this.txt.length - 1);
		} else {
			this.txt = fullTxt.substring(0, this.txt.length + 1);
		}

		this.el.innerHTML = `<span class="typewrite-wrap line-height-2 font-size-xl h1 text-transform-capitalize text-pink font-weight-bold">${this.txt}</span>`;

		const that = this;
		let delta = 200 - Math.random() * 100;

		if (this.isDeleting) {
			delta /= 2;
		}

		if (!this.isDeleting && this.txt === fullTxt) {
			delta = this.period;
			this.isDeleting = true;
		} else if (this.isDeleting && this.txt === '') {
			this.isDeleting = false;
			this.loopNum++;
			delta = 500;
		}

		setTimeout(() => {
			that.tick();
		}, delta);
	}
}

window.onload = () => {
	const elements = document.getElementsByClassName('typewrite');
	for (let i = 0; i < elements.length; i++) {
		const toRotate = elements[i].getAttribute('data-type');
		const period = elements[i].getAttribute('data-period');
		if (toRotate) {
			// eslint-disable-next-line no-new
			new TxtType(elements[i], JSON.parse(toRotate), period);
		}
	}
};

// ************* //////// ************* //
// ** // Slider functionality  ** //
// ************* //////// ************* //

// Select all the slider containers
const sliders = document.querySelectorAll(
	'.before-after-container .before-after-slider',
);

sliders.forEach((slider) => {
	const afterElement = slider.querySelector('.after');
	const sliderButton = slider.querySelector('.before-after-button');
	const sliderDragButton = slider.querySelector('.btn-drag');

	let isDragging = false;
	let startX;
	let sliderStartX;

	function moveSlider(e) {
		if (!isDragging) return;

		const clientX = e.type.includes('mouse')
			? e.clientX
			: e.touches[0].clientX;
		const deltaX = clientX - startX;
		const newLeft = Math.max(
			0,
			Math.min(
				sliderStartX + deltaX,
				slider.offsetWidth - sliderButton.offsetWidth,
			),
		);

		sliderButton.style.left = `${newLeft}px`;
		const clipWidth = (newLeft / slider.offsetWidth) * 100;
		afterElement.style.clipPath = `inset(0 ${100 - clipWidth}% 0 0)`;
	}
	sliderDragButton.addEventListener('mousedown', (e) => {
		isDragging = true;
		startX = e.clientX;
		const rect = slider.getBoundingClientRect();
		sliderStartX = e.clientX - rect.left - sliderButton.offsetWidth / 2;
		e.preventDefault();
	});

	sliderDragButton.addEventListener('touchstart', (e) => {
		isDragging = true;
		startX = e.touches[0].clientX;
		const rect = slider.getBoundingClientRect();
		sliderStartX =
			e.touches[0].clientX - rect.left - sliderButton.offsetWidth / 2;
		e.preventDefault();
	});

	document.addEventListener('mouseup', () => {
		isDragging = false;
	});

	document.addEventListener('mousemove', (e) => {
		moveSlider(e);
	});

	document.addEventListener('touchend', () => {
		isDragging = false;
	});

	document.addEventListener('touchmove', (e) => {
		moveSlider(e);
	});
});

const videoSliders = document.querySelectorAll(
	'.before-after-container-video .before-after-slider-video',
);

videoSliders.forEach((sliderContainer) => {
	const afterContainer = sliderContainer.querySelector('.video.after');

	const sliderButton = sliderContainer.querySelector('.before-after-button');

	const sliderDragButton = sliderButton.querySelector('.btn-drag');

	let isDragging = false;
	let startX;

	function moveSlider(e) {
		if (!isDragging) return;
		const clientX = e.type.includes('mouse')
			? e.clientX
			: e.touches[0].clientX;
		const deltaX = clientX - startX;
		const newLeft = Math.max(
			0,
			Math.min(
				deltaX,
				sliderContainer.offsetWidth - sliderButton.offsetWidth,
			),
		);

		// Adjust the left position and width of the "after" video container
		afterContainer.style.width = `${newLeft}px`;
		afterContainer.style.left = `${newLeft}px`;
		sliderButton.style.left = `${newLeft}px`;
	}

	// Mouse events
	sliderDragButton.addEventListener('mousedown', (e) => {
		isDragging = true;
		startX = e.clientX - afterContainer.offsetWidth;
		e.preventDefault();
	});

	document.addEventListener('mouseup', () => {
		isDragging = false;
	});

	document.addEventListener('mousemove', (e) => {
		if (isDragging) {
			moveSlider(e);
		}
	});

	// Touch events
	sliderDragButton.addEventListener('touchstart', (e) => {
		isDragging = true;
		startX = e.touches[0].clientX - afterContainer.offsetWidth;
		e.preventDefault();
	});

	document.addEventListener('touchend', () => {
		isDragging = false;
	});

	document.addEventListener('touchmove', (e) => {
		if (isDragging) {
			moveSlider(e);
		}
	});
});

function downloadPDF(pdfUrl, formId) {
	console.log(pdfUrl, formId);
	const downloadLink = document.createElement('a');
	const modalElement = document.getElementById(`modal_hbspt_${formId}`);
	const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
	downloadLink.href = pdfUrl;
	downloadLink.target = '_blank';
	downloadLink.download = '';
	document.body.appendChild(downloadLink);
	downloadLink.click();
	document.body.removeChild(downloadLink);
	modalElement.style.display = 'none';
	modalBackdrop.remove();
}

if (typeof window !== 'undefined') {
	(function loadHubSpotForm() {
		const script = document.createElement('script');
		script.src = 'https://js.hsforms.net/forms/v2.js';
		script.async = true;
		script.onload = () => {
			if (window.hbspt) {
				window.hbspt.forms.create({
					portalId: 'YOUR_PORTAL_ID',
					formId: 'YOUR_FORM_ID',
					target: '#hubspot-form',

					// eslint-disable-next-line no-unused-vars
					onFormReady: (form) => {},

					// eslint-disable-next-line no-unused-vars
					onFormSubmit: (form) => {
						return false;
					},

					onFormSubmitted: (form) => {
						// Get the form's ID
						const formId = form.getAttribute('data-form-id');

						// Get the corresponding PDF URL from the hidden <a> tag
						const pdfLink = document.querySelector(
							`a.playbook-pdf-link[data-playbook-id="hbspt_${formId}"]`,
						);

						if (pdfLink) {
							downloadPDF(pdfLink.href, formId);
						}
						return false;
					},
				});
			}
		};
		document.body.appendChild(script);
	})();
}

// eslint-disable-next-line no-unused-vars
const viewAllCards = (className) => {
	const items = document.querySelectorAll(`.${className}`);
	items.forEach((item) => (item.style.display = 'block'));
	document.getElementById(`view-all-${className}`).style.display = 'none';
	document.getElementById(`show-less-${className}`).style.display = 'block';
};

// eslint-disable-next-line no-unused-vars
const showLessCards = (className) => {
	const items = document.querySelectorAll(`.${className}`);
	for (let i = 0; i < items.length; i++) {
		if (i >= 3) {
			items[i].style.display = 'none';
		} else {
			items[i].style.display = 'block';
		}
	}
	document.getElementById(`view-all-${className}`).style.display = 'block';
	document.getElementById(`show-less-${className}`).style.display = 'none';
};

// Add event listeners for the buttons
document
	.getElementById('view-all-best-practices-expander')
	.addEventListener('click', () => {
		viewAllCards('best-practices-expander');
	});

document
	.getElementById('show-less-best-practices-expander')
	.addEventListener('click', () => {
		showLessCards('best-practices-expander');
	});
document
	.getElementById('view-all-playbooks-expander')
	.addEventListener('click', () => {
		viewAllCards('playbooks-expander');
	});

document
	.getElementById('show-less-playbooks-expander')
	.addEventListener('click', () => {
		showLessCards('playbooks-expander');
	});

window.addEventListener('message', (event) => {
	if (
		event.data.type === 'hsFormCallback' &&
		event.data.eventName === 'onFormSubmitted'
	) {
		const formId = event.data.id;
		const modalElement = document.getElementById(`modal_hbspt_${formId}`);
		if (modalElement) {
			const labelElement =
				modalElement.querySelector('#signupModalLabel');
			if (labelElement) {
				labelElement.style.display = 'none';
			}
		}
	}
});
